<template>
    <div id="not-found-page">
        <van-nav-bar title="地址不存在" />
        <div class="page-content">
            <van-empty image="network" description="404 Not Found" />
        </div>
    </div>
</template>

<script>
import { Empty, NavBar } from 'vant';

export default {
    name: 'not-found',
    components: {
        'van-nav-bar': NavBar,
        'van-empty': Empty
    }
};
</script>

<style lang="less" scoped>
#not-found-page {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .page-content {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
    }
}
</style>
